import React from 'react';

interface Props {
  id: string;
}

export const OwnerMap = ({ id, }:Props) => {
  return (
    <div>
      mapa { id }
    </div>
  );
};
